export const footerTexts = {
  en: {
    links: {
      getInTouch: 'Get in touch',
      contactUs: 'Contact us',
      customerSupport: 'Customer support',
      aboutSamt: 'About SAMT',
      joinUs: 'Join us',
      siteInformation: 'Site information',
      siteMap: 'Site map',
      legalTerms: 'Legal terms',
      downloads: 'Download'
    },
    copyright:
      'All rights reserved© Shanghai Advanced Metallurgical Technology Corporation | 沪ICP备18044778号-1'
  },
  zh: {
    links: {
      getInTouch: '联系我们',
      contactUs: '联系方式',
      customerSupport: '客户支持',
      aboutSamt: '关于先越',
      joinUs: '加入我们',
      siteInformation: '站点信息',
      siteMap: '网站地图',
      legalTerms: '法律条款',
      downloads: '下载中心'
    },
    copyright:
      '版权所有© 上海先越冶金技术股份有限公司 <br/>| 沪ICP备18044778号-1'
  }
}

export const getFooterTexts = (lang) => {
  return footerTexts[lang] || footerTexts['en']
}
